   

    export const SOMATIC_GENOME_COVERAGE = [
        {
            Header: 'Gene symbol',
            accessor: "gene_symbol",
            filter: '',
        },
        {
            Header: 'Transcript',
            accessor: "transcript",
            filter: '',
        },
        {
            Header: 'Mean coverage',
            accessor: "mean_coverage",
            filter: '',
        },
        {
            Header: 'C1',
            accessor: "c1",
            filter: '',
        },
        {
            Header: 'C10',
            accessor: "c10",
            filter: '',
        },
        {
            Header: 'C15',
            accessor: "c15",
            filter: '',
        }, 
        {
            Header: 'C20',
            accessor: "c20",
            filter: '',
        },

    ];